import {
    Briefcase, CalendarDays, Compass, FileText, Gift, HandHeart, Landmark, MessageSquareLock,
    PartyPopper, PiggyBank, Presentation, Scale, ShieldCheck, Sparkles, UsersRound, type LucideIcon,
} from 'lucide-react'
import type { IconKey } from './model'

export const ICONS: Record<IconKey, LucideIcon> = {
    sparkles: Sparkles,
    gift: Gift,
    party: PartyPopper,
    calendar: CalendarDays,
    landmark: Landmark,
    board: Presentation,
    coins: PiggyBank,
    heart: HandHeart,
    briefcase: Briefcase,
    users: UsersRound,
    message: MessageSquareLock,
    compass: Compass,
    scale: Scale,
    shield: ShieldCheck,
    file: FileText,
}
